export interface SiteVideoPublic {
    location: string
    videoUrl: string
}

export const useSiteVideos = () => {
    const config = useRuntimeConfig()
    const apiBase = config.public.apiBase

    const getAll = async (): Promise<SiteVideoPublic[]> => {
        try {
            const data = await $fetch<SiteVideoPublic[]>(`${apiBase}/oxoweb/sitevideos`)
            return data || []
        } catch (e) {
            console.error('Error fetching site videos:', e)
            return []
        }
    }

    return { getAll }
}
